import { CharacterRelateRefs } from "hooks/asocijator/character/useCharacterRelateRefs";
import { CharacterRelate } from "type/common/character/character.type";
import { CharacterImportResponse } from "./dto/character_import.type";
import { CHAR_CHECK_KEY_GROUP } from "components/common/answer/answer_util/PronounceInput/PronounceInput.const";
import { CharacterLetter, CharacterResult } from "./dto/CharacterResult";
import { CharacterFile } from "./dto/CharacterFile";
import { CHARACTER_FILE_ROLE } from "constant/character/character.constant";
import { filterDuplicatesSuccesive } from "common/util/array/array_common";

export const characterRelateDefaultGet = (): CharacterRelate => {
  return {
    meaning: [],
    pronounce: [],
    shape: [],
  };
};

export const characterRelateFromRefs = (
  refs: CharacterRelateRefs
): CharacterRelate => {
  return {
    meaning: refs.relateMeaningRef.current,
    pronounce: refs.relatePronounceRef.current,
    shape: refs.relateShapeRef.current,
    contain: refs.relateContainRef.current,
  };
};

export function characterImportResponseDefault(): CharacterImportResponse {
  return {
    imported: [],
    notImported: [],
    messages: [],
  };
}

export function sizeInfoGet(size: null | number): string {
  let result: string = "";
  if (size !== null) {
    if (size < 1000) {
      result = `(${size} KB)`;
    } else {
      let sizeMB: number = size / 1000;
      sizeMB = Math.round(sizeMB * 100) / 100;
      result = `(${sizeMB} MB)`;
    }
  }

  return result;
}

export const getFlattenPronounce = (pronounce: string): string => {
  let result = pronounce;
  Object.entries(CHAR_CHECK_KEY_GROUP).forEach(([key, letters]) => {
    const regStr = letters.join("|");
    const reg = new RegExp(regStr, "g");
    result = result.replaceAll(reg, key);
  });

  return result;
};

export const isCharacterFileRoleSignImage = (
  charFile: CharacterFile
): boolean => charFile.role === CHARACTER_FILE_ROLE.SIGN_IMAGE;

export const getSignImagePath = (character: CharacterResult): string | null => {
  let result: string | null = null;
  if (character.file) {
    const fileSignImage = character.file.find((charFile: CharacterFile) =>
      isCharacterFileRoleSignImage(charFile)
    );
    if (fileSignImage) {
      result = fileSignImage.path;
    }
  }

  return result;
};

export const getCharacterLetter = (
  characterLetter: CharacterLetter,
  checkSignImage: boolean = false
): string => {
  let result = characterLetter.letter;
  if (checkSignImage && characterLetter.signImage) {
    result = characterLetter.signImage;
  }

  return result;
};

export function filterCharactersByLetters(characters: any[]): any[] {
  let result = characters.sort((a: any, b: any) =>
    a.letter.localeCompare(b.letter, "zh")
  );
  result = filterDuplicatesSuccesive<any>(
    result,
    (a: any, b: any) => a.letter === b.letter
  );

  return result;
}
